
import creditCardType from 'credit-card-type'
import {
  Component, Mixins, Prop, Watch,
} from 'vue-property-decorator'

import ValidatorMixin from '@/shared/mixins/validator/ValidatorMixin'

import CheckoutForm from '../models/CheckoutForm'

import EButton from './Button.vue'
import Card from './Card.vue'
import ECreditCardInput from './CreditCardInput.vue'
import EInput from './Input.vue'
import ESelect from './Select.vue'
import ETaxIdInput from './TaxIdInput.vue'

@Component({
  components: {
    EButton,
    EInput,
    ECreditCardInput,
    Card,
    ESelect,
    ETaxIdInput,
  },
})
export default class CreditCardForm extends Mixins(ValidatorMixin) {
  @Prop() readonly data!: CheckoutForm

  @Prop({ type: Boolean, default: false }) readonly use3ds!: boolean

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  private card = this.data.payment.card!

  private expiryDate = ''

  $refs!: {
    creditcard: Card
    number: ECreditCardInput
  }

  private get cvvConfig() {
    const [cardType = {}] = creditCardType(this.card.number)
    const { code = {} } = cardType
    const size = code.size || 3

    return {
      mask: Array(size).fill('#').join(''),
      size,
    }
  }

  get taxIdTypes(): string[] {
    switch (this.data.payment.country) {
      case 'MX': return ['CC', 'PP', 'CURP', 'RFC']
      case 'CO': return ['CC', 'NIT', 'CE', 'TI', 'PP']
      case 'CL': return ['CC', 'PP', 'RUT']
      case 'PE': return ['CE', 'PAS', 'RUC', 'DNI']
      case 'EC': return ['PAS', 'RUC', 'CI']
      case 'CR': return ['CI', 'DIMEX']
      default: return []
    }
  }

  get shouldShowTaxIdTypeField(): boolean {
    return this.data.payment.country !== 'BR'
  }

  @Watch('expiryDate')
  onExpiryDateChanged(val: string) {
    if (val.length === 5) {
      const month = val.slice(0, 2)
      const year = `20${val.slice(3)}`

      this.card.month = Number(month)
      this.card.year = Number(year)

      this.$refs.creditcard.validThru = val
    }
  }

  @Watch('card.number')
  onCardNumberChanged(val: string) {
    const [cardType = {}] = creditCardType(val)
    const { type = 'none' } = cardType
    this.$refs.creditcard.cardType = val ? type : 'none'
    this.$refs.creditcard.cardNumber = this.$refs.number.prettyCardNumber(val) || '**** **** **** ****'
  }

  @Watch('card.holder')
  onCardHolderChanged(val: string) {
    this.$refs.creditcard.cardHolder = val || '***** ****'
  }

  @Watch('card.cvv')
  onCardCvvChanged(val: string) {
    this.$refs.creditcard.cvv = val || 'CVV'
  }

  created() {
    const { person } = this.data
    const { month, year } = this.card

    this.card.holder = `${person.firstName} ${person.surname}`

    if (month && year) {
      this.expiryDate = `${[0, month].join('').slice(-2)}/${year?.toString().slice(-2)}`
    }

    if (person.taxIdType && !this.taxIdTypes.includes(person.taxIdType)) {
      person.taxIdType = undefined
    }
  }

  mounted() {
    this.goFront()
  }

  goFront() {
    this.$refs.creditcard.goFront()
  }

  goBack() {
    this.$refs.creditcard.goBack()
  }
}
